import {Component, Inject, OnInit} from '@angular/core';
import { ProductDTO} from 'tekkeys-common';
import { selectCartItem} from 'store/cart/cart.selectors';
import {UntypedFormControl} from '@angular/forms';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {LocalCartService} from 'shared/services/localCart.service';
import {LocalQuotationService} from 'shared/services/localQuotations.service';
import {selectIsConnected} from 'store/account/account.selectors';
import {debounceTime, distinctUntilChanged, take} from 'rxjs/operators';
import {setQuantity} from 'store/cart/cart.actions';
import {addToQuotationItem} from 'store/quotation/quotation.actions';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { DaysLeftPipe } from 'shared/pipes/days-left/days-left.pipe';
import { PriceCalculator } from 'src/app/utils/business/priceCalculator';
import { selectCompanyPageLoading } from 'store/company/company.selectors';
export interface DATAPRODUCT {
  cartQuantity: number;
  product: ProductDTO;
  quantity: number;
  cartItemId: number;
  overQuantity: number;
  devisQuantity: number;
  localCartQuantity: number;
  remainder: boolean;
  status: string;
  image: string;
}
@Component({
  selector: 'app-add-to-card-popup',
  templateUrl: './add-to-card-popup.component.html',
  styleUrls: ['./add-to-card-popup.component.scss']
})
export class AddToCardPopupComponent implements OnInit {

  MESSAGE =
    'Livraison estimée dans 24-48 heures après la validation de la commande.';
  imageUrl = null;
  cartItem = this.store.select(selectCartItem(this.data.cartItemId));
  quantity: UntypedFormControl = new UntypedFormControl();
  max: number;
  quotation: boolean;
  finalQuantity = 0;
  discountDaysLeft: number = null;
  productPriceCalculator: PriceCalculator;

  constructor(
    private dialogRef: MatDialogRef<AddToCardPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DATAPRODUCT,
    private router: Router,
    private store: Store,
    private localCartService: LocalCartService,
    private localQuotationService: LocalQuotationService

  ) {
    this.productPriceCalculator = new PriceCalculator(this.data.product, this.discountDaysLeft);
  }

  displayDeee: boolean = false;
  ngOnInit() {
    this.store.select(selectCompanyPageLoading).subscribe(me => {
      if(me.addresses[0].country.name === 'France') {
        this.displayDeee = true;
      }
    });
    this.finalQuantity = 0;
    this.quotation = this.data?.status !== 'IN_STOCK' && !this.data.remainder;
    this.quantity.setValue(this.data.quantity);

    this.store.select(selectIsConnected).subscribe((isConnected) => {
      if (isConnected) {
        this.finalQuantity = this.data?.cartQuantity + this.data.quantity - this.quantity.value ;
      }
      else if (!isConnected){
        this.finalQuantity = this.data.cartQuantity + this.data.quantity - this.quantity.value ;
      }
    });
    this.imageUrl = this.data.image;
    if (!this.imageUrl) {
      this.imageUrl = 'assets/imtech-new-logo.svg';
    }
    let quantity = this.data.quantity;
      const daysLeftPipe = new DaysLeftPipe();
      
      if (this.data.product.discount) {
        this.discountDaysLeft = daysLeftPipe.transform(
          new Date(this.data.product?.discountEndDate)
        );
      }
    this.productPriceCalculator = new PriceCalculator(this.data.product, this.discountDaysLeft);

    this.max = this.data.product.quantity;
    this.quantity.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((payload: number) => {
        this.store.select(selectIsConnected).subscribe((isConnected) => {
          if (!isConnected) {
            const cartItem = this.localCartService.getCartItem(
              this.data.product.id
            );
            this.localCartService.addCartItem(
              cartItem.product,
              payload - quantity
            );
            quantity = payload;
          }
        });
        this.cartItem.pipe(take(1)).subscribe((carTItem) => {
          this.store.dispatch(
            setQuantity({
              cartItemId: this.data.cartItemId,
              quantity: carTItem.quantity + payload - quantity,
            })
          );
        });

        quantity = payload;
      });
  }

  close() {
    this.dialogRef.close();
  }

  goToCart() {
    this.close();
    this.router.navigate(['/checkout']);
  }
  OpenQuotation(){
    this.store.select(selectIsConnected).subscribe((isConnected) => {
      if (!isConnected) {
        this.localQuotationService.addQuotationItem(
          this.data.product,
          this.data.cartQuantity
        );
         this.store.dispatch(
        addToQuotationItem({
          productId: this.data.product.id,
          quantity: this.data.cartQuantity,
          price: 0,
        })
      );
        return;
      }
      const prices = (this.data.product.price - this.data.product.discount) * this.finalQuantity;
      this.store.dispatch(
        addToQuotationItem({
          productId: this.data.product.id,
          quantity: this.data.devisQuantity,
          price: prices,
        })
      );
    });
    this.router.navigate(['/checkout']);

  }

  calculatePrice(): number {
     if (this.discountDaysLeft > 0) {
      if (this.data.product?.discountType == 'FIX') {
        return this.data.product.price - this?.data.product?.discount;
      } else if (this.data.product?.discountType == 'PERCENTAGE') {
        return this.data.product?.price * (1 - this.data.product?.discount);
      }
    }

    return this.data.product?.price;
     
  }

  displayDiscount() {
    return this.productPriceCalculator.displayDiscount();
  }

}
